import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function resetICalExportToken() {
  const res = await fetchOrchidAPI("/api/scheduler/calendar/ical/token", {
    method: "DELETE",
  });
  if (!res.ok) {
    throw new Error(
      `failed to reset iCal token: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
